import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Drawer } from 'antd';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import BulkUploadBatchForm from './BulkUploadBatchForm';
import './style.scss';

const BulkUploadBatch = ({
  user, customClass, disabled, customStyle, onBulkUploadBatch, parentKey, inventoryLocationId, inventoryLocationPath,
}) => {
  const [visibleUpload, setVisibleUpload] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  return (
    <Fragment>
      <div
        className={`${customClass} ${disabled ? 'disabled-button' : ''}`}
        onClick={() => {
          if (!disabled) {
            setVisibleUpload(true);
          }
        }}
        style={customStyle}
      >
        <FontAwesomeIcon icon={faPlusCircle} />
        &nbsp;
        Upload Batches
      </div>

      <Drawer
        open={visibleUpload}
        onClose={() => setVisibleUpload(false)}
        showHeader
        width="650px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '597px' }}>
            <H3Text text="Upload Batches" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setVisibleUpload(false)} />
          </div>
        </div>
        <BulkUploadBatchForm
          parentKey={parentKey}
          onBulkUploadBatch={(batchData) => onBulkUploadBatch(batchData)}
          callback={() => setVisibleUpload(false)}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
          inventoryLocationId={inventoryLocationId}
          inventoryLocationPath={inventoryLocationPath}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ProductReducers }) => ({
  user: UserReducers.user,
  getProductBySkusLoading: ProductReducers.getProductBySkusLoading,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkUploadBatch));
